import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/book-avatar.svg'
import _imports_1 from '../assets/images/typing-loading.gif'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex chat-content message" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column flex-grow-1"
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex align-self-end action-icon-container"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column chat-content chat-suggestions"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-content-end prompt"
}
const _hoisted_9 = { class: "chat-content" }

import { computed } from 'vue';
import { Notyf } from 'notyf';
import VueMarkdown from 'vue-markdown-render'
import markdownItLinkAttributes from 'markdown-it-link-attributes'
import MarkdownColor from 'markdown-it-color';
import Chat from '@/interfaces/Chat';
import MarkdownIt from 'markdown-it';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  props: {
    chat: {},
    isShareEnabled: { type: Boolean },
    isPromptingEnabled: { type: Boolean }
  },
  emits: ["onPromptSuggestionSelected", "onShareClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const markdownPlugins = computed(() => {
    return [
        (md: MarkdownIt) => md.use(markdownItLinkAttributes, {
            matcher(href: string){ return href.startsWith('https:') && href.includes('#nounderline') },
            attrs: {
                target: '_blank',
                style: 'color: #68444A; text-decoration: none;',
                rel: 'noopener noreferrer'
            }
        }),
        (md: MarkdownIt) => md.use(markdownItLinkAttributes, {
            pattern: /^(https?:|mailto:)/,
            attrs: {
                target: '_blank',
                style: 'color: #68444A',
                rel: 'noopener noreferrer'
            }
        }),
        (md: MarkdownIt) => md.use(MarkdownColor, {
            inline: true,
        })
    ];
});

const notyf = new Notyf({
    duration: 1500,
    ripple: false,
    position: { x: 'center', y: 'top' },
    types: [
        {
            type: 'success',
            background: 'grey',
        }
    ]
})

async function copyToClipboard() {
    await navigator.clipboard.writeText(props.chat.content);
    notyf.success({ message: '複製成功' });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.chat.type === 'bot')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)),
            (props.chat.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "loading-message" }, "輸入中 ", -1),
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "loading-gif",
                    alt: ""
                  }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_unref(VueMarkdown), {
                    source: _ctx.chat.content,
                    plugins: markdownPlugins.value
                  }, null, 8, ["source", "plugins"]),
                  (props.isShareEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("a", {
                          class: "action-icon",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onShareClick', 'line', _ctx.chat)))
                        }, _cache[2] || (_cache[2] = [
                          _createStaticVNode("<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" data-v-46b5b243><g clip-path=\"url(#clip0_3698_12370)\" data-v-46b5b243><g clip-path=\"url(#clip1_3698_12370)\" data-v-46b5b243><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5 0C5.9 0 0.5 5.4 0.5 12C0.5 18.6 5.9 24 12.5 24C19.1 24 24.5 18.6 24.5 12C24.5 5.4 19.1 0 12.5 0ZM18.8 14.9C17.1 16.8 13.4 19.2 12.5 19.5C11.6 19.9 11.8 19.3 11.8 19.1C11.8 19 11.9 18.4 11.9 18.4C11.9 18.2 12 17.9 11.9 17.7C11.8 17.5 11.5 17.4 11.2 17.3C7.4 16.8 4.5 14.1 4.5 10.9C4.5 7.3 8.1 4.4 12.5 4.4C16.9 4.4 20.5 7.3 20.5 10.9C20.5 12.3 19.9 13.6 18.8 14.9Z\" data-v-46b5b243></path><path d=\"M17.8 12.9002H15.6C15.5 12.9002 15.5 12.8002 15.5 12.8002V9.3002C15.5 9.2002 15.6 9.2002 15.6 9.2002H17.8C17.9 9.2002 17.9 9.3002 17.9 9.3002V9.9002C17.9 10.0002 17.8 10.0002 17.8 10.0002H16.3V10.6002H17.8C17.9 10.6002 17.9 10.7002 17.9 10.7002V11.3002C17.9 11.4002 17.8 11.4002 17.8 11.4002H16.3V12.0002H17.8C17.9 12.0002 17.9 12.1002 17.9 12.1002V12.7002C18 12.9002 17.9 12.9002 17.8 12.9002Z\" data-v-46b5b243></path><path d=\"M9.50001 12.9002C9.60001 12.9002 9.60001 12.8002 9.60001 12.8002V12.2002C9.60001 12.1002 9.50001 12.1002 9.50001 12.1002H8.00001V9.3002C8.00001 9.2002 7.90001 9.2002 7.90001 9.2002H7.30001C7.20001 9.2002 7.20001 9.3002 7.20001 9.3002V12.8002C7.20001 12.9002 7.30001 12.9002 7.30001 12.9002H9.50001Z\" data-v-46b5b243></path><path d=\"M10.3 9.09961H10.9C11 9.09961 11.1 9.19961 11.1 9.29961V12.7996C11.1 12.8996 11 12.9996 10.9 12.9996H10.3C10.2 12.9996 10.1 12.8996 10.1 12.7996V9.29961C10.2 9.19961 10.2 9.09961 10.3 9.09961Z\" data-v-46b5b243></path><path d=\"M14.7 9.09961H14.1C14 9.09961 14 9.19961 14 9.19961V11.2996L12.4 9.09961H11.8C11.7 9.09961 11.7 9.19961 11.7 9.19961V12.6996C11.7 12.7996 11.8 12.7996 11.8 12.7996H12.4C12.5 12.7996 12.5 12.6996 12.5 12.6996V10.5996L14.1 12.7996H14.7C14.8 12.7996 14.8 12.6996 14.8 12.6996V9.29961C14.9 9.19961 14.8 9.09961 14.7 9.09961Z\" data-v-46b5b243></path></g></g><defs data-v-46b5b243><clipPath id=\"clip0_3698_12370\" data-v-46b5b243><rect width=\"24\" height=\"24\" fill=\"white\" transform=\"translate(0.5)\" data-v-46b5b243></rect></clipPath><clipPath id=\"clip1_3698_12370\" data-v-46b5b243><rect width=\"24\" height=\"24\" fill=\"white\" transform=\"translate(0.5)\" data-v-46b5b243></rect></clipPath></defs></svg>", 1)
                        ])),
                        _createElementVNode("a", {
                          class: "action-icon",
                          onClick: copyToClipboard
                        }, _cache[3] || (_cache[3] = [
                          _createElementVNode("svg", {
                            width: "25",
                            height: "24",
                            viewBox: "0 0 25 24",
                            fill: "none",
                            stroke: "currentColor",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M16.6 16.1H21.5V3H8.40002V7.9",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }),
                            _createElementVNode("path", {
                              d: "M16.6 7.90039H3.5V21.0004H16.6V7.90039Z",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ], -1)
                        ]))
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          (props.chat.suggestions.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("div", null, "您可以這麼問...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat.suggestions, (item, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    class: _normalizeClass(["suggestion", { 'suggestion-disabled': !_ctx.isPromptingEnabled }]),
                    onClick: ($event: any) => (emit('onPromptSuggestionSelected', item))
                  }, _toDisplayString(item), 11, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (props.chat.type === 'user')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.chat.content), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})